"use strict";

console.info("Script cart-shipping-calculator.js loaded");

// -------------------------------------------------
// Função debounce para evitar chamadas excessivas
// -------------------------------------------------
function debounce(func, delay) {
  let timeoutId;
  return function(...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(this, args), delay);
  };
}

// -------------------------------------------------
// CONFIGURAÇÕES FIXAS
// -------------------------------------------------
const SHIPPING_COUNTRY = "BR";
const SHIPPING_PROVINCE = "SP";

// -------------------------------------------------
// ELEMENTOS DA PÁGINA DO CARRINHO
// -------------------------------------------------
const cartEstimatorWrap = document.querySelector("[data-estimate-shipping-wrap]");
const cartId = cartEstimatorWrap ? cartEstimatorWrap.getAttribute("data-id") : "";
const cartCepInput = document.getElementById("ShippingZip_" + cartId);
const cartEstimateBtn = document.querySelector("[data-action='estimate-shipping']");
const cartResponseRatesContainer = document.querySelector("[data-response-rates]");
const cartShippingSummary = document.getElementById("cart-shipping-value");

// -------------------------------------------------
// GERENCIAMENTO DO CEP NO localStorage
// -------------------------------------------------
function saveCartCep(cep) {
  localStorage.setItem("shipping_cep", cep);
  localStorage.setItem("user_cep", cep);
}

function getCartCep() {
  return localStorage.getItem("shipping_cep") || "";
}

// -------------------------------------------------
// Atualiza o resumo do frete com base no valor salvo
// -------------------------------------------------
function updateCartShippingSummary() {
  const summaryElement = document.getElementById("cart-shipping-value");
  console.debug("Elemento de resumo encontrado:", summaryElement);
  if (!summaryElement) return;
  const savedPrice = localStorage.getItem("selected_shipping_price");
  if (savedPrice && !isNaN(parseFloat(savedPrice))) {
    const value = parseFloat(savedPrice);
    summaryElement.innerText = (value === 0)
      ? "Grátis"
      : ` ${value.toFixed(2).replace('.', ',')}`;
  } else {
    summaryElement.innerText = "CALCULE O FRETE";
  }
  console.debug("Shipping summary updated to:", summaryElement.innerText);
}


// -------------------------------------------------
// MutationObserver para garantir que o resumo não seja sobrescrito
// -------------------------------------------------
function observeCartShippingSummary() {
  if (!cartShippingSummary) return;
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      // Se o valor for "CALCULE O FRETE", forçamos a atualização
      if (cartShippingSummary.innerText.trim() === "CALCULE O FRETE") {
        updateCartShippingSummary();
      }
    });
  });
  observer.observe(cartShippingSummary, { childList: true, subtree: true });
}
observeCartShippingSummary();

// -------------------------------------------------
// BUSCA OS DADOS DO CARRINHO (/cart.js)
// -------------------------------------------------
function fetchCartData() {
  return fetch("/cart.js").then(response => response.json());
}

// -------------------------------------------------
// CHAMA A API DE FRETE
// -------------------------------------------------
function fetchCartShippingRates(cep) {
  const url = `/cart/shipping_rates.json?shipping_address[zip]=${encodeURIComponent(cep)}&shipping_address[country]=${SHIPPING_COUNTRY}&shipping_address[province]=${SHIPPING_PROVINCE}`;
  console.debug("Calling shipping rates API with URL:", url);
  return fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error(`Erro na API de frete: ${response.status}`);
      }
      return response.json();
    });
}

// -------------------------------------------------
// MONTA E EXIBE AS OPÇÕES DE FRETE COM RADIO BUTTONS
// -------------------------------------------------
function displayCartShippingRates(rates) {
  if (!cartResponseRatesContainer) return;
  
  if (!rates || rates.length === 0) {
    cartResponseRatesContainer.innerHTML = "<p>Calculando...</p>";
    return;
  }
  
  let html = '<ul class="shipping-rates-list" style="list-style:none; margin:0; padding:0;">';
  
  rates.forEach((rate, index) => {
    const name = rate.name || "";
    let prazo = "";
    if (rate.delivery_days && Array.isArray(rate.delivery_days) && rate.delivery_days.length > 0) {
      const minDias = rate.delivery_days[0];
      const maxDias = rate.delivery_days[1] || minDias;
      prazo = (minDias === maxDias)
        ? `Entrega em até ${minDias} dias úteis`
        : `Entrega em ${minDias} a ${maxDias} dias úteis`;
    } else if (rate.delivery_range && Array.isArray(rate.delivery_range) && rate.delivery_range.length === 2) {
      prazo = `Entrega entre ${rate.delivery_range[0]} e ${rate.delivery_range[1]}`;
    } else if (rate.description) {
      prazo = rate.description;
    }
    
    const priceVal = parseFloat(rate.price);
    const price = priceVal === 0
      ? "Grátis"
      : ` ${priceVal.toFixed(2).replace('.', ',')}`;
    
    // Incluímos também dados extras: carrier, service, handle
    const carrier = rate.carrier || "";
    const service = rate.service || "";
    const handle = rate.handle || rate.code || "";
    
    html += `
      <li class="shipping-option-container" style="padding:10px 0; border-bottom:1px solid #eaeaea;">
        <label style="display:block; cursor:pointer;">
          <input type="radio" name="shipping_method_cart" value="${rate.code}" 
                 data-rate-name="${name}" 
                 data-rate-price="${priceVal}" 
                 data-rate-delivery="${prazo}"
                 data-rate-carrier="${carrier}"
                 data-rate-service="${service}"
                 data-rate-handle="${handle}"
                 style="margin-right:10px;">
          <div class="shipping-option-header" style="display:flex; justify-content:space-between; align-items:center;">
            <span class="shipping-name" style="font-weight:600; color:#333;">${name}</span>
            <span class="shipping-price" style="font-weight:600; color:#333;">${price}</span>
          </div>
          <div class="shipping-delivery" style="color:#666; font-size:1em;">${prazo}</div>
        </label>
      </li>
    `;
  });
  
  html += "</ul>";
  cartResponseRatesContainer.innerHTML = html;
  restoreSelectedShipping();
}

// -------------------------------------------------
// Restaura a opção de frete salva ou, se não houver e o usuário não escolheu manualmente, tenta auto‑selecionar frete grátis
// -------------------------------------------------
// Restaura a opção de frete salva ou, se o usuário não escolheu manualmente, tenta auto‑selecionar frete grátis
function restoreSelectedShipping() {
  let savedShippingCode = localStorage.getItem("selected_shipping_code");
  const radios = Array.from(document.getElementsByName("shipping_method_cart"));
  let found = false;

  if (savedShippingCode) {
    radios.forEach(radio => {
      if (radio.value === savedShippingCode) {
        radio.checked = true;
        // Atualiza sempre os dados do frete com os valores atuais da API
        localStorage.setItem("selected_shipping_price", parseFloat(radio.getAttribute("data-rate-price")).toFixed(2));
        localStorage.setItem("selected_shipping_carrier", radio.getAttribute("data-rate-carrier") || "");
        localStorage.setItem("selected_shipping_service", radio.getAttribute("data-rate-service") || "");
        localStorage.setItem("selected_shipping_handle", radio.getAttribute("data-rate-handle") || "");
        localStorage.setItem("selected_shipping_name", radio.getAttribute("data-rate-name"));
        found = true;
      }
    });
  }
  
  // Se não encontrou o código salvo ou não há seleção manual, auto‑seleciona uma opção
  if (!found && radios.length > 0) {
    // Tenta selecionar frete grátis se disponível
    let freeOption = radios.find(radio => parseFloat(radio.getAttribute("data-rate-price")) === 0);
    if (!freeOption) {
      freeOption = radios[0];
    }
    freeOption.checked = true;
    savedShippingCode = freeOption.value;
    localStorage.setItem("selected_shipping_code", savedShippingCode);
    localStorage.setItem("selected_shipping_name", freeOption.getAttribute("data-rate-name"));
    localStorage.setItem("selected_shipping_price", parseFloat(freeOption.getAttribute("data-rate-price")).toFixed(2));
    localStorage.setItem("selected_shipping_carrier", freeOption.getAttribute("data-rate-carrier") || "");
    localStorage.setItem("selected_shipping_service", freeOption.getAttribute("data-rate-service") || "");
    localStorage.setItem("selected_shipping_handle", freeOption.getAttribute("data-rate-handle") || "");
  }
  
  updateCartShippingSummary();
}



// -------------------------------------------------
// Captura alterações nos radio buttons e atualiza a seleção
// -------------------------------------------------
document.addEventListener("change", function(e) {
  if (e.target && e.target.name === "shipping_method_cart") {
    const radio = e.target;
    localStorage.setItem("selected_shipping_code", radio.value);
    localStorage.setItem("selected_shipping_name", radio.getAttribute("data-rate-name"));
    localStorage.setItem("selected_shipping_price", parseFloat(radio.getAttribute("data-rate-price")).toFixed(2));
    localStorage.setItem("selected_shipping_carrier", radio.getAttribute("data-rate-carrier") || "");
    localStorage.setItem("selected_shipping_service", radio.getAttribute("data-rate-service") || "");
    localStorage.setItem("selected_shipping_handle", radio.getAttribute("data-rate-handle") || "");
    localStorage.setItem("user_chose_shipping", "true");
    updateCartShippingSummary();
    console.debug("Radio changed:", {
      code: radio.value,
      name: radio.getAttribute("data-rate-name"),
      price: radio.getAttribute("data-rate-price")
    });
  }
});

// -------------------------------------------------
// Função principal para calcular o frete na página do carrinho
// -------------------------------------------------
function calculateCartShipping() {
  if (cartResponseRatesContainer) {
    cartResponseRatesContainer.innerHTML = "<p>Calculando...</p>";
  }
  
  const cep = getCartCep().trim();
  if (!cep) {
    cartResponseRatesContainer.innerHTML = "<p>Digite seu CEP para calcular o frete.</p>";
    return;
  }
  
  fetchCartData().then(cart => {
    if (cart.item_count === 0) {
      cartResponseRatesContainer.innerHTML = "";
      return;
    }
    fetchCartShippingRates(cep)
      .then(ratesData => {
        displayCartShippingRates(ratesData.shipping_rates);
      })
      .catch(error => {
        console.error("Erro ao calcular frete:", error);
        cartResponseRatesContainer.innerHTML = "<p>Calculando...</p>";
      });
  });
}

// -------------------------------------------------
// EVENTOS NA PÁGINA DO CARRINHO
// -------------------------------------------------
document.addEventListener("DOMContentLoaded", function() {
  const savedCep = getCartCep();
  if (cartCepInput && savedCep) {
    cartCepInput.value = savedCep;
  }
  
  fetchCartData().then(cart => {
    if (cart.item_count > 0 && savedCep) {
      calculateCartShipping();
    }
  });
  
  if (cartEstimateBtn) {
    cartEstimateBtn.addEventListener("click", function() {
      const cep = cartCepInput.value.trim();
      if (cep) {
        saveCartCep(cep);
        calculateCartShipping();
      } else {
        alert("Por favor, digite um CEP válido.");
      }
    });
  }
  
  if (cartCepInput) {
    cartCepInput.addEventListener("keypress", function(e) {
      if (e.key === "Enter") {
        e.preventDefault();
        const cep = cartCepInput.value.trim();
        if (cep) {
          saveCartCep(cep);
          calculateCartShipping();
        } else {
          alert("Por favor, digite um CEP válido.");
        }
      }
    });
  }
  
  // Dispara o cálculo via evento "cart:updated" com debounce
  const debouncedCalculateShipping = debounce(calculateCartShipping, 500);
  document.addEventListener("cart:updated", debouncedCalculateShipping);
  
  // Força atualização do resumo do frete após atualizações do carrinho (aguarda 3000ms)
  document.addEventListener("cart:updated", function() {
    setTimeout(updateCartShippingSummary, 3000);
  });
});

// Função para atualizar o total do carrinho dinamicamente
function updateMainCartTotal() {
  console.debug("updateMainCartTotal() foi chamada");
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // cart.total_price vem em centavos; por exemplo, 9980 para R$99,80
      let baseTotalCents = cart.total_price; 
      
      // Lê o valor do frete do localStorage (em reais)
      let shippingFeeReais = parseFloat(localStorage.getItem("selected_shipping_price"));
      if (isNaN(shippingFeeReais)) { 
        shippingFeeReais = 0;
      }
      
      // Converte o frete para centavos
      let shippingFeeCents = Math.round(shippingFeeReais * 100);
      
      // Calcula o novo total em centavos
      let newTotalCents = baseTotalCents + shippingFeeCents;
      console.debug("baseTotalCents:", baseTotalCents, "shippingFeeCents:", shippingFeeCents, "newTotalCents:", newTotalCents);
      
      // Formata o total para exibição
      let formattedTotal = " " + (newTotalCents / 100).toFixed(2).replace('.', ',');
      
      // Atualiza o elemento no DOM
      let totalElement = document.getElementById("cart-total-value");
      if (totalElement) {
        totalElement.innerText = formattedTotal;
        console.debug("Total atualizado para:", formattedTotal);
      }
    })
    .catch(error => console.error("Erro ao atualizar o total do carrinho:", error));
}

// Exemplo de uso: quando o usuário seleciona um método de frete
document.addEventListener("change", function(e) {
  if (e.target && e.target.name === "shipping_method_cart") {
    const radio = e.target;
    const selectedShippingPrice = parseFloat(radio.getAttribute("data-rate-price")).toFixed(2);
    
    // Atualiza os dados no localStorage
    localStorage.setItem("selected_shipping_code", radio.value);
    localStorage.setItem("selected_shipping_name", radio.getAttribute("data-rate-name"));
    localStorage.setItem("selected_shipping_price", selectedShippingPrice);
    localStorage.setItem("selected_shipping_carrier", radio.getAttribute("data-rate-carrier") || "");
    localStorage.setItem("selected_shipping_service", radio.getAttribute("data-rate-service") || "");
    localStorage.setItem("selected_shipping_handle", radio.getAttribute("data-rate-handle") || "");
    localStorage.setItem("user_chose_shipping", "true");
    
    // Atualiza o resumo de frete (se existir uma função para isso)
    updateCartShippingSummary && updateCartShippingSummary();
    
    // Atualiza o total dinamicamente
    updateMainCartTotal();
    
    console.debug("Frete selecionado:", {
      code: radio.value,
      name: radio.getAttribute("data-rate-name"),
      price: selectedShippingPrice
    });
  }
});

// Além disso, se o carrinho for atualizado via evento, force a atualização do total
document.addEventListener("cart:updated", function() {
  // Delay para garantir que outras atualizações já ocorreram
  setTimeout(updateMainCartTotal, 2000);
});

// E, se necessário, atualize ao carregar a página
document.addEventListener("DOMContentLoaded", function() {
  updateMainCartTotal();
});








































































































